// import { lens as viemLens } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const lens = {
  displayName: 'Lens',
  runtime: 'evm',
  // Lens was added to viem in 2.26.4 but we're on ^2.24.3; regardless, the `lens` key is correct
  // Disco TODO: Update viem package to fix
  // viemChain: viemLens,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'lens' },
    qnStreams: {
      networkKey: 'lens-mainnet',
    },
  }),
} as const satisfies AllChainConfig<'evm', false>;
